<template>
  <div class="app-container">
    <el-row>
      <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
        <el-tab-pane key="one" :label="$t('billingPage.CAMPARE')" name="one" />
        <el-tab-pane key="two" :label="$t('billingPage.DBFILE')" name="two" />
        <el-tab-pane key="thr" :label="$t('billingPage.HISTORY')" name="thr" />
      </el-tabs>
    </el-row>
    <shipping-campare v-show="queryParamsTradeStatus=='one'" :data-info="dataInfo" 
      @compare="_compareShippingCharge" @gotoCharge="_gotoCharge" @importToDb="_importToDb" />
    <!-- dbSavedFileHistoryList -->
    <db-Saved-File-History v-show="queryParamsTradeStatus=='two'" />
    <!-- surchargedFileHistoryList -->
    <surcharged-File-History v-show="queryParamsTradeStatus=='thr'" />
  </div>
</template>
<script>
import { billApi } from '@/api';
import shippingCampare from './components/shippingCampare';
import dbSavedFileHistory from './components/dbSavedFileHistory';
import surchargedFileHistory from './components/surchargedFileHistory';
export default {
  name: 'BusinessAbnormalOrderProcessing',
  components: {
    shippingCampare,
    dbSavedFileHistory,
    surchargedFileHistory,
  },
  data() {
    return {
      colSpan: 6,
      queryParams: null,
      queryParamsTradeStatus: 'one',
      dataInfo: {
        unmatchedItems: [],
        matchedItems: [],
        surchargeTransactions: []
      },
    };
  },
  mounted(){
    // this.dataInfo = this.dataMock
  },
  methods: {
    _compareShippingCharge(val) {
      billApi.compareShippingCharge(val).then((res) => {
        res.data.totalDiffPercent = res.data.totalDiffPercent / 100;
        this.dataInfo = res.data;
      });
    },
    _gotoCharge(val) {
      billApi.chargeShippingCharge(val).then((res) => {
        if (res.code == 200) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
        }
      });
    },
    _importToDb(val) {
      billApi.importToDB(val).then((res) => {
        if (res.code == 200) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
        }
      });
    },
    // tab页点击方法
    handleTabClick(tab, event) {
      this.queryParamsTradeStatus = tab.name;
    },
  },
};
</script>
